import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Brain, ShieldAlert, EyeOff, Activity } from 'lucide-react';
export function PainSection() {
  const painPoints = [{
    icon: <Brain className="w-8 h-8" data-id="element-85" />,
    text: 'Ansiedad antes del encuentro'
  }, {
    icon: <ShieldAlert className="w-8 h-8" data-id="element-86" />,
    text: 'Falta de confianza'
  }, {
    icon: <Activity className="w-8 h-8" data-id="element-87" />,
    text: 'Pensar demasiado'
  }, {
    icon: <EyeOff className="w-8 h-8" data-id="element-88" />,
    text: 'Evitar situaciones íntimas'
  }, {
    icon: <AlertCircle className="w-8 h-8" data-id="element-89" />,
    text: 'Sentir que perdés el control'
  }];
  return <section className="py-24 bg-black relative overflow-hidden" data-id="element-90">
      {/* Red ambient glow */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-red-glow opacity-30 pointer-events-none" data-id="element-91"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-92">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-93">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2" data-id="element-94">
            <div className="rounded-2xl overflow-hidden border border-white/10 box-glow-red" data-id="element-95">
              <img src="https://cdn.magicpatterns.com/uploads/64zW3KqBq4XBdmyTCJTKBz/ChatGPT_Image_19_jun_2026,_21_41_04.png" alt="Hombre preocupado" className="w-full h-auto object-cover" data-id="element-96" />
            </div>

            <div className="mt-8" data-id="element-97">
              <h2 className="text-5xl md:text-6xl font-teko font-bold text-white leading-none mb-4" data-id="element-98">
                NO ES SOLO{' '}
                <span className="text-intense-red text-glow-red" data-id="element-99">TERMINAR</span>
                <br data-id="element-100" />
                DEMASIADO RÁPIDO
              </h2>
              <div className="w-20 h-1 bg-intense-red mb-6" data-id="element-101"></div>
              <p className="text-xl text-gray-300 font-medium" data-id="element-102">
                La eyaculación precoz no solo afecta el momento.
              </p>
              <p className="text-xl text-gray-300 font-medium mt-2" data-id="element-103">
                Puede afectar tu tranquilidad, tu autoestima y la confianza que
                sentís en vos mismo.
              </p>
            </div>
          </motion.div>

          <div className="w-full lg:w-1/2 grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-104">
            {painPoints.map((point, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1,
            duration: 0.5
          }} className={`bg-panel-bg border border-white/5 p-6 rounded-xl flex flex-col items-center text-center gap-4 hover:border-intense-red/50 hover:bg-intense-red/5 transition-all duration-300 ${idx === painPoints.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-105">
                <div className="p-4 rounded-full bg-black border border-white/10 text-gray-400 group-hover:text-intense-red transition-colors" data-id="element-106">
                  {point.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-200" data-id="element-107">
                  {point.text}
                </h3>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}